import { useState, useContext } from 'react'
import { IoMenuOutline } from "react-icons/io5";
import { ClientContext } from '../../../contexts/clientProvider';
import { UserContext } from '../../../contexts/userProvider';
import Normal from './types/normal';
import Group from './types/group';
import { BiArrowBack } from 'react-icons/bi'
import Logo from '../../../assets/images/VOX  Branca e Verde Horizontal.png'

const SideBar = ({ handleSideBar, sideBar, setSelectedItem, components, selectedItem, handleItemClick }) => {
    const { setAlert } = useContext(UserContext);
    const { clientes } = useContext(ClientContext);
    const [expandedItems, setExpandedItems] = useState([]);

    const toggleExpand = (item) => {
        if (expandedItems.includes(item)) {
          setExpandedItems(expandedItems.filter((i) => i !== item));
        } else {
          setExpandedItems([...expandedItems, item]); 
        }
    };
    
    const handleLinkClick = (item) => {
        if(!clientes){
            setAlert({ visible: true, title: "Atenção!", placeholder: "Aguarde o carregamento dos clientes.", confirm: false, type: "warning" })
            return;
        }
        handleItemClick(item);
        setSelectedItem(item);
        if (item.links && item.links.length > 0) {
            toggleExpand(item.name); 
        } 
    }

    return (
        <>
        {/* Overlay para mobile */}
        {sideBar && (
            <div 
                className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                onClick={handleSideBar}
            />
        )}
        
        <div className={`
            ${sideBar ? 'w-64 lg:w-72 xl:w-80' : 'w-16 sidebar-collapsed'} 
            transition-all duration-300 ease-in-out
            bg-gradient-to-b from-vox-blue-900 to-vox-blue-950 
            dark:from-gray-900 dark:to-gray-950
            text-white border-r border-vox-green-500 
            flex flex-col h-screen shadow-vox-2xl 
            fixed lg:relative top-0 left-0 z-50 lg:z-30
            ${!sideBar ? '-translate-x-full lg:translate-x-0' : 'translate-x-0'}
        `}>
            <div className={`
                ${sideBar ? 'p-4 flex justify-between items-center' : 'p-3 flex justify-center'} 
                border-b border-vox-green-500/30 bg-vox-blue-800 dark:bg-gray-800
            `}>
                {sideBar && (
                    <img src={Logo} alt='logo' className='h-8 w-auto object-contain' />
                )}
                <button
                    onClick={handleSideBar}
                    className='p-2 rounded-lg hover:bg-vox-green-600 transition-colors duration-200 text-white hover:text-white'
                    title={sideBar ? 'Fechar menu' : 'Abrir menu'}
                    data-tour-id='menu:alternar'
                >
                    {sideBar ? 
                        <BiArrowBack className='w-6 h-6' /> : 
                        <IoMenuOutline className='w-6 h-6' />
                    }
                </button>
            </div>
            
            <div className='flex-1 overflow-y-auto p-3 flex flex-col'>
                <ul className='space-y-2 flex-1'>
                    {components.map((item, index) => (
                        <li 
                            className={`
                                ${selectedItem === item.name ? 
                                    'bg-vox-green-600 border-l-4 border-vox-green-400 shadow-lg sidebar-item-selected' : 
                                    'hover:bg-vox-blue-700 dark:hover:bg-gray-700'
                                } 
                                rounded-lg transition-all duration-200
                            `} 
                            key={index}
                        >
                            {item.isGroup ? (
                                <Group 
                                    selectedItem={selectedItem}
                                    title={item.name}
                                    sideBar={sideBar}
                                    links={item.links}  
                                    handleLinkClick={handleLinkClick} 
                                />
                            ) : (
                                <Normal 
                                    title={item.name}
                                    sideBar={sideBar}
                                    handleLinkClick={() => handleLinkClick(item.name)} 
                                />
                            )}
                        </li>
                    ))}
                </ul>
                
                {/* Botão Sair fixo no final */}
                <div className='pt-4 border-t border-vox-blue-700 dark:border-gray-700 mt-auto'>
                    <div className='hover:bg-vox-blue-700 dark:hover:bg-gray-700 rounded-lg transition-all duration-200'>
                        <Normal title='Sair' sideBar={sideBar} />
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default SideBar
